export const ACTUALIZAR_LIST_ACTIVOTYPE = "ACTUALIZAR_LIST_ACTIVOTYPE";
export const MODIFICAR_ACTIVOTYPE = "MODIFICAR_ACTIVOTYPE";
export const AGREGAR_ACTIVOTYPE = "AGREGAR_ACTIVOTYPE";  
export const ELIMINAR_ACTIVOTYPE = "ELIMINAR_ACTIVOTYPE";